<app-announcement-bar></app-announcement-bar>
<app-navbar-user [active]="'admin'"></app-navbar-user>
<app-loading-spinner *ngIf="isLoading"></app-loading-spinner>
<div class="container-fluid dashboard  p-4 main-content">
    <div class="row">
        <div class="col-md-12 mb-3">
            <div class="d-md-flex align-items-center justify-content-between d-block">
                <div class="d-flex align-items-center">
                    <h2 class="m-0 page-title"><i class="bx bxs-cog"></i> Admin</h2>
                </div>

            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">

            <tabset>
                <tab [heading]="'Codes'">
                    <div class="card  w-100 shadow-sm mb-4" >
                        <div class="card-header d-flex justify-content-between align-items-center">
                            <h5 class="card-title mb-0">Codes</h5>
                            <div>
                                <button class="btn btn-sm btn-darken" (click)="onShowGenerateCodesForm()">Generate Codes</button>
                            </div>
                            

                        </div>
                        <div class="card-body pt-2 pb-3">
                            <!-- codes here -->

                            <app-data-table *ngIf="codes && codes.length>0" [rows]="codes" [cols]="[
      { name: 'Code', id: 'code', sortable: true },
      { name: 'Items', id: 'item_ids', sortable: true },
      { name: 'Access Days', id: 'access_days', sortable: true },
      { name: 'Created', id: 'created', sortable: true },
      { name: 'Redeemed', id: 'redeemed', sortable: true },
      { name: 'User ID', id: 'user_id', sortable: true }
    ]" [sort]="'created'" [order]="'desc'" [tableClass]="'table-sm data-table-alt table-borderless'"
                                    [paginationClass]="'pagination-sm'"></app-data-table>

                        </div>
                    </div>
                </tab>
            </tabset>

        </div>
    </div>
</div>
<app-footer></app-footer>